import React from 'react'

// Bootstrap Components
import Container from 'react-bootstrap/Container'

// Custom Components
import NavigationBar from '../navigationbar/NavigationBar'
import Footer from '../footer/Footer'

// CSS
import './index.css'



export default function Layout({content}) {
  return (
    <>
    <NavigationBar />
      <Container className='layout'>

        {content}

      </Container>
    <Footer />
    </>
  )
}
